import { useDispatch, useSelector } from "react-redux";
import styles from "./profile.module.scss";
import { closeProfile, getCurrentUserId, getProspectId } from "features/authSlice";
import { ReactComponent as ChevronLeft } from "assets/images/v2/chevron-left-test.svg";
import { ReactComponent as TriangleExclamation } from "assets/images/v2/triangleExclamation.svg";
import { ReactComponent as Xmark } from "assets/images/v2/xmark-large.svg";
import { useCallback, useEffect, useState } from "react";
import { useGetBorrowerDetailsQuery } from "pages/dashboard/home/dashboardService";
import {
  PROFILE_ERROR_LOAD_INFO,
  PROFILE_SETTINGS_TITLE,
} from "utilities/Constant";
import ProfileNameContactInfo from "components/v2/profile-name-contactInfo/ProfileNameContactInfo";
import ProfileCommunicationPreferences from "components/v2/profile-communication-preferences/ProfileCommunicationPreferences";
import ProfileResetPassword from "components/v2/profile-reset-password/ProfileResetPassword";
import { useGetPreferencesUrlQuery } from "services/common/complianceService";
import { useGetFeatureFlagsQuery } from "services/common/featureFlagService";
import ToastMessage from "components/ui/toast-message/ToastMessage";
import useDesktopChecker from "hooks/useDesktopChecker";

export default function ProfileSettings() {
  const dispatch = useDispatch();
  const userId = useSelector(getCurrentUserId);

  const borrowerDetails = useGetBorrowerDetailsQuery(userId, { skip: userId === "" });
  const borrower = borrowerDetails.data;
  const [exiting, setExiting] = useState(false);
  const complianceId = useSelector(getProspectId);
  const { data, isLoading } = useGetPreferencesUrlQuery(complianceId);
  const [showErrToast, setShowErrToast] = useState(false);
  const isDesktop = useDesktopChecker();
  const { data: featureFlag } = useGetFeatureFlagsQuery();

  const handleBack = () => {
    setExiting(true);
    setTimeout(() => {
      dispatch(closeProfile());
    }, 300);
  };

  const onClickPreference = useCallback(() => {
    if (isLoading) return;

    if (data?.preferenceCenterLink) {
      window.open(data.preferenceCenterLink, "_blank");
    } else {
      setShowErrToast(true);
    }
  }, [isLoading, data]);

  useEffect(() => {
    if (showErrToast) {
      const timer = setTimeout(() => {
        setShowErrToast(false);
      }, 4000);

      return () => clearTimeout(timer);
    }
  }, [showErrToast]);

  return (
    <>
      {showErrToast && (
        <ToastMessage
          header="Link Unavailable"
          message="Please try again later or contact support"
          state="error"
          timeout={4000}
          position={isDesktop ? "top-center" : "bottom-center"}
        />
      )}

      <div className={`${styles.bodyContent} ${exiting ? styles['exit-animation'] : ""}`}>
        <div className={styles.profileContent}>
          <div className={styles.profileHeader}>
            {isDesktop && <button className={styles.backBtn} onClick={handleBack} aria-label="Go back" title="Back">
              <ChevronLeft className="icon" />
            </button>}
            <span className={styles.headerTitle}>{PROFILE_SETTINGS_TITLE}</span>
            {!isDesktop && <button className={styles.backBtn} onClick={handleBack} aria-label="Go back" title="Back">
              <Xmark className={styles.profileCloseIcon} />
            </button>}
          </div>

          {borrowerDetails.isError && (
            <div className={styles.profileErrorWrapper}>
              <div className={styles.profileInfoError}>
                <TriangleExclamation className={styles.profileInfoErrorIcon} />
                {PROFILE_ERROR_LOAD_INFO}
              </div>
            </div>
          )}

          <ProfileNameContactInfo borrower={borrower} />
          <ProfileCommunicationPreferences onClickPreference={onClickPreference} />
          {featureFlag?.borrowerProfilePasswordResetEnabled === true && <ProfileResetPassword />}
        </div>
      </div>
    </>
  );
}
